import { motion } from "framer-motion";

export default function VoiceOrb({ state = "idle", size = 220 }) {
  const active = state !== "idle";
  const bars = Array.from({ length: 24 });
  return (
    <div data-testid="voice-waveform-visualizer" className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      <motion.div
        className="absolute inset-0 rounded-full bg-[var(--accent)] opacity-20 blur-2xl"
        animate={{ scale: active ? [1, 1.25, 1] : [1, 1.06, 1] }}
        transition={{ duration: active ? 1.2 : 4, repeat: Infinity }}
      />
      <motion.div
        className="relative rounded-full orb-gradient shadow-2xl flex items-center justify-center"
        style={{ width: size * 0.7, height: size * 0.7 }}
        animate={{ scale: active ? [1, 1.05, 1] : 1 }}
        transition={{ duration: 0.8, repeat: Infinity }}
      >
        <div className="flex items-end gap-[3px] h-1/3">
          {bars.slice(0, 12).map((_, i) => (
            <motion.span
              key={i}
              className="w-[3px] rounded-full bg-white/90"
              animate={{ height: active ? ["20%", `${40 + ((i * 37) % 60)}%`, "20%"] : "18%" }}
              transition={{ duration: 0.6 + (i % 4) * 0.12, repeat: Infinity, delay: i * 0.05 }}
            />
          ))}
        </div>
      </motion.div>
      <span data-testid="voice-orb-state" className="absolute -bottom-2 label-mono text-[var(--text-muted)]">
        {{ idle: "En veille", listening: "J'écoute…", thinking: "Je réfléchis…", speaking: "Sem.IA parle" }[state]}
      </span>
    </div>
  );
}
